<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <div style="display: flex;width: 100%;">
        <el-form :inline="true" style="display: flex;flex-wrap: wrap;" label-width="110px">
          <el-form-item label="月份">
            <el-date-picker v-model="queryInfo.monthYMD" type="month" placeholder="请选择月份" value-format="yyyy-MM" @change="look" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" label-width="20px">
            <div>共有<span style="color:var(--color-info-blue)">{{ total }}</span>个搜索结果</div>
          </el-form-item>
        </el-form>
      </div>
      <div class="flex-row-end" >
        <el-button type="primary" @click="onExport">导出</el-button>
      </div>
      <div class="flex-row-between2">
        <div
          style="margin-top:10px;overflow-y: scroll;width:min(250px,30%);margin-right:10px" :style="{ height: pageHeight }">
          <el-input v-if="steachertreeall.length > 0" v-model="departname" placeholder="输入科室名称搜索"
            @input="getsteacherList2" clearable style="width: min(230px, 100%); "></el-input>
          <el-tree ref="departtree" :default-expand-all="true" :expand-on-click-node="false" show-checkbox
            @check="handleNodeClick2" :data="steachertree2" :props="defaultProps3" accordion node-key="id"
            :highlight-current="true" style=" font-size: 14px"><span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span style="color: rgb(0, 122, 221, 1)"
                v-if="data.count !== 0 && data.count !== null && data.count !== ''">
                {{ " (" + data.count + ") " || "" }}
              </span>
            </span></el-tree>
        </div>
        <!-- 用户列表区域 -->
        <el-table :data="dataList" border stripe :height="pageHeight">
          <el-table-column align="center" label="序号" type="index"></el-table-column>
          <el-table-column align="center" v-for="col in columns" :key="col.prop" :prop="col.prop" :label="col.label"></el-table-column>
          <el-table-column align="center" prop="trainCount" label="已发布培训任务数">
            <template slot-scope="scope">
              <el-button  type="text" @click="jump(scope.row,'trainCount')">{{scope.row.trainCount}}</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="theoryCount" label="已发布理论考试数">
            <template slot-scope="scope">
              <el-button  type="text" @click="jump(scope.row,'theoryCount')">{{scope.row.theoryCount}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-col style="text-align: right;margin: 10px 0;">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-col>
    </el-card>

  </div>
</template>
<script>
import dayjs from 'dayjs'
import axios from 'axios'

export default {
  data() {
    return {
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        deptIdsStr:'',
        monthYMD: dayjs().format('YYYY-MM')
      },
      pageHeight:'',
      dataList: [],
      steachertree2:[],
      steachertreeall: [],
      departname: '',
      defaultProps3: {
        children: "subList",
        label: "name",
      },
      total:0,
      columns:[
        {
          prop:'month',
          label:'月份'
        },
        {
          prop:'name',
          label:'科室名称'
        },
      ]
    }
  },
  watch: {
    '$route'(to, from) {
      console.log(to, '切屏回来')
      if (to.path == '/trainManagement') {
        // this.handleWindowFocus()
        this.getlist()
      }
    },
  },
  created() {
    this.pageHeight = document.documentElement.clientHeight - 360 + 'px'
    this.getsteacherList2()
    this.getlist()
  },
  methods: {
    onExport(){
      let params = this.queryInfo
      axios.get(axios.defaults.baseURL + "/training/statistic/get/month/statistic/list/export", {
        responseType: 'blob',
        params,
      }).then(res => {
          const fileName ='科室统计'+params.monthYMD;
          const _res = res.data;
          let blob = new Blob([_res]);
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName + '.xls'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch(err => {
          this.$message.error(err)
        });
    },
    jump(row,type){
      if (type == 'trainCount') {
        // 点击已发布培训 跳转到 培训管理-已发布培训-科室页签下并带上科室和时间参数 ，
        this.$router.push({
          path: '/trainPub',
          query: {
            startStr: dayjs(row.month).startOf('month').format('YYYY-MM-DD'),
            endStr: dayjs(row.month).endOf('month').format('YYYY-MM-DD'),
            deptId:row.deptId,
          }
        })
      } else if (type == 'theoryCount') {
        // 已发布理论考试跳转：考试管理-发布理论考试-科室，带上科室和日期的查询条件
        this.$router.push({
          path: '/examCreate',
          query: {
            startStr: dayjs(row.month).startOf('month').format('YYYY-MM-DD'),
            endStr: dayjs(row.month).endOf('month').format('YYYY-MM-DD'),
            deptId:row.deptId,
          }
        })
      }
    },
    // 树形控件-勾选
    handleNodeClick2(data, checked, indeterminate) {
      this.treeList = JSON.parse(JSON.stringify(data));
      const checkedNodes = this.$refs.departtree.getCheckedNodes()
      this.checkedNodes = checkedNodes
      let cpyId = []
      checkedNodes.forEach((i) => {
        if (i.type == 1) {
          cpyId.push(i.cpyId)
        }
      })
      let cdids = []
      checkedNodes.forEach((i) => {
        cdids.push(i.id)
      })
      this.queryInfo.deptIdsStr = cdids.join(',')
      this.look();
    },
    // 获取科室树数据
    async getsteacherList2() {
      let param = {
        name: this.departname
      }
      const { data: res } = await this.$Http.steacherTree(param);
      if (res.result !== 0) {
        return this.$message.error(res.data.msg);
      }

      this.steachertreeall = res.data;
      let arr = [{
        campusId: '',
        id: '',
        name: '全部',
        subList: this.steachertreeall,
        count: ''
      }]
      this.steachertree2 = arr;
    },
    // 监听 pageSize 改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getlist()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getlist()
    },
    // 获取表格数据
    async getlist() {
      if ( !this.queryInfo.monthYMD ) {
        this.$message.error('请选择月份')
        return
      }
      let params = JSON.parse(JSON.stringify(this.queryInfo))
      const {
        data: res
      } = await this.$http({
        url:'/training/statistic/get/month/statistic/list',
        method:'get',
        params
      })
      if (res.result !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataList = res.data.list
      this.total = res.data.total
    },
    look() {
      this.queryInfo.pageNum = 1
      this.getlist()
    },

  }
}
</script>
<style lang="less" scoped>
</style>
